import { take } from '@execonline-inc/collections';
import { emptyFragment, useOpenable } from '@execonline-inc/execonline-ui';
import { whenPositive } from '@execonline-inc/numbers';
import { AlreadyTranslated } from '@execonline-inc/translations';
import { observer } from 'mobx-react';
import { ExperienceCompetencyChip } from '../../../../../../../../Native/AEP/Common/Experience/ExperienceCompetencies';
import {
  handleEnterKeyDown,
  handleMouseDown,
} from '../../../../../../../../Native/AEP/Common/Types';
import { Competency } from '../../../../../../PrimaryCompetencies/PrimaryCompetenciesStore';

interface Props {
  competencies: Competency[];
}

function Competencies({ competencies }: Props) {
  const { isOpen: expanded, onOpen } = useOpenable();

  const items = expanded ? competencies : [...take(4, competencies)];
  const restCount = whenPositive(competencies.length - items.length);

  return (
    <div className="flex flex-wrap gap-1 sm:gap-2">
      {items.map((value) => (
        <ExperienceCompetencyChip key={value.id}>
          <AlreadyTranslated content={value.name} />
        </ExperienceCompetencyChip>
      ))}
      {restCount
        .map((count) => (
          <ExperienceCompetencyChip
            tabIndex={0}
            className="cursor-pointer"
            onClick={handleMouseDown(onOpen)}
            onKeyDown={handleEnterKeyDown(onOpen)}
          >
            +{count}
          </ExperienceCompetencyChip>
        ))
        .getOrElse(emptyFragment)}
    </div>
  );
}

export default observer(Competencies);
